import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'nullable-boolean',
    templateUrl: './nullable-boolean.component.html',
    styleUrls: ['./nullable-boolean.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NullableBooleanComponent {
  @Input() value: boolean | null;
  @Input() name: string;
  @Input() disabled: boolean = false;

  @Output() valueChange: EventEmitter<boolean | null> = new EventEmitter<
    boolean | null
  >();

  onClick($event: Event) {
    let target = $event.target as HTMLElement;
    let input: HTMLInputElement | null;
    $event.preventDefault();
    $event.stopPropagation();
    if (!this.disabled) {
      if (target.tagName === 'INPUT') {
        input = target as HTMLInputElement;
      } else if (target.tagName === 'SPAN') {
        input = target.parentElement?.querySelector('input') ?? null;
      } else {
        input = target.querySelector('input');
      }
      if (input) {
        let value = input.value === 'true';
        if (this.value === null || this.value !== value) {
          this.value = value;
          this.valueChange.emit(this.value);
        } else {
          this.value = null;
          this.valueChange.emit(this.value);
        }
      }
    }
  }
}
